import { action, runInAction, makeAutoObservable } from 'mobx';

import { State } from '~/store/types';
import { Site, SiteBody, WatcherrError } from '@ixicare/resources';
import BuildingStore from './Building';
import { UserAction } from '~/config/toastNotification';
import { t } from '~/i18n';
import Building from './Building';
class SiteSettingsStore {
  rootStore: State;
  buildingsLoaded: boolean = false;
  loading: boolean = false;
  error?: WatcherrError;
  buildings: Building[] = [];

  constructor(rootStore: State) {
    makeAutoObservable(this, {
      loadBuildings: action.bound,
      createBuilding: action.bound,
    });
    this.rootStore = rootStore;
  }

  loadBuildings() {
    if (this.buildingsLoaded || this.loading) {
      return;
    }

    this.loading = true;
    Site.getSites()
      .then((sites) => {
        runInAction(() => {
          this.loading = false;

          this.buildingsLoaded = true;
          this.buildings = sites.map((site) => new BuildingStore(this.rootStore, site));
        });
      })
      .catch((err) => {
        runInAction(() => {
          this.loading = false;
          this.error = err;
        });
      });
  }

  createBuilding(body: SiteBody): Promise<BuildingStore> {
    return new Promise((resolve, reject) => {
      Site.createSite(body)
        .then((site) => {
          const building = new BuildingStore(this.rootStore, site);

          runInAction(() => {
            this.buildings.push(building);
            this.rootStore.notifications.addUserActionNotification({
              type: UserAction.SiteCreate,
              notificationType: 'success',
              message: t('alerts.site.create.success', {
                siteName: building.name,
              }),
            });
            resolve(building);
          });
        })
        .catch((err) => {
          this.error = err;
          reject();
        });
    });
  }
}

export default SiteSettingsStore;
